import { Delete } from "lucide-react";

const KEYS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "0",
  "back",
] as const;

/**
 * On-screen number pad for cashier amount entry (donor `NumberPad`).
 * Exists primarily for mobile: tapping digits beats summoning the OS
 * keyboard over a bottom-sheet modal. Pure presentation — emits logical
 * keys; the owning pane applies the amount-string rules.
 */
export function NumberPad({ onKey }: { onKey: (key: string) => void }) {
  return (
    <div aria-label="Number pad" className="cashier-numpad" role="group">
      {KEYS.map((key) => (
        <button
          aria-label={key === "back" ? "Delete last digit" : key}
          key={key}
          onClick={() => onKey(key)}
          type="button"
        >
          {key === "back" ? <Delete aria-hidden size={17} /> : key}
        </button>
      ))}
    </div>
  );
}
